// extracted by mini-css-extract-plugin
module.exports = {"footerMenu__title":"c3_rj","footerMenu__items":"c3_rk","footerMenu__item":"c3_rl","footerMenu__icon":"c3_rm","footerMenu__links":"c3_rn","footerMenu__link":"c3_rp"};